import { Component, OnInit } from '@angular/core';
import { VacanciesService } from '../../../core/vacancy/vacancies.service';
import { environment } from '../../../../environments/environment';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogConfig } from '@angular/material';
import { EditPasswordComponent } from './edit-password/edit-password.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthNoticeService, AuthService, Login } from '../../../core/auth';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import { Subject } from 'rxjs';
import Swal from 'sweetalert2';


const BASE_URL = environment.BASE_URL;
@Component({
  selector: 'kt-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {

  profileData: any;
  profilePicture: any;
  profileForm: FormGroup;
  loading: boolean;
  private unsubscribe: Subject<any>;
  @BlockUI() blockUI: NgBlockUI;
  requestedUpdates: any;

  constructor(private vacancyService: VacanciesService,
    private authNoticeService: AuthNoticeService,
    private fb: FormBuilder,
    private auth: AuthService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.profileData = this.getProfileDetails();
    this.initProfileForm();
    if(this.profileData.userType=="Doctor"){
      this.getRequestedUpdates();
    }
   


    this.profilePicture = BASE_URL + "api/" + this.profileData.pic

  }

  initProfileForm() {
    if (!this.authNoticeService.onNoticeChanged$.getValue()) {
      const initialNotice = `You can now initiate your First Name, Last Name, or Other Name update for admin update
			`;
      this.authNoticeService.setNotice(initialNotice, 'success');
    }

    this.profileForm = this.fb.group({
      firstName: [this.profileData.firstname, Validators.compose([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
      ])
      ],
      lastName: [this.profileData.lastname, Validators.compose([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ])
      ],
      otherName: [this.profileData.othername, Validators.compose([
        Validators.minLength(3),
        Validators.maxLength(100)
      ])
      ]
    });
  }

  getProfileDetails() {
    return this.vacancyService.getCurrentUserDetails()
  }
  onPasswordEdit() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "40%";
    this.dialog.open(EditPasswordComponent, dialogConfig)
  }

  onUpdate() {

    const controls = this.profileForm.controls;
    /** check form */
    if (this.profileForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }


    const changes = {};
    Object.keys(controls).forEach(key => {
      const control = this.profileForm.get(key);
      if (control.dirty) {
        changes[key] = control.value;
      }
    });


    this.loading = true;
    this.blockUI.start('Processing...');

    this.auth
      .requestUpdate(changes)
      .subscribe(data => {
        this.loading = false;
        this.blockUI.stop();
        Swal.fire(
          data.message,
          'An admin will review your request soon',
          'success'
        )
        if(this.profileData.userType=="Doctor"){
          this.getRequestedUpdates();
        }
     
      }, error => {
        this.blockUI.stop();
        this.loading = false;
        Swal.fire(
          error.error.message,
          'Update request failed',
          'error'
        )
      });


  }

  getRequestedUpdates() {
    return this.auth.getRequestedUpdate().subscribe((data) => {
      this.requestedUpdates = data.records.filter(x=>x.status=='pending')
    }, (error) => {
      Swal.fire(
        error.error.message,
        'Request failed',
        'error'
      )

    })
  }

}
